import { AuthService } from '@app/modules/auth/auth.service'
import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core'
import { FormBuilder, FormGroup } from '@angular/forms'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { DestroyService } from '@app/core/services/destroy.service'
import dayjs, { Dayjs } from 'dayjs'
import { DocumentItem } from '../documents/document.model'

@Component({
  selector: 'lin-record-edit-dialog',
  templateUrl: './record-edit-dialog.component.html',
  styleUrls: ['./record-edit-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DestroyService],
  standalone: false,
})
export class RecordEditDialogComponent implements OnInit {
  form: FormGroup

  get isNotExpiring(): boolean {
    return !!this.form?.get('noExpiry')?.value
  }

  get issueDate(): Dayjs {
    const dateFormat = this.authService.getCurrentUserDateFormat()
    return dayjs(<Dayjs>this.form?.get('issueDate')?.value, dateFormat).tz()
  }

  get issueDateIsValid(): boolean {
    return this.issueDate.isValid()
  }

  get expDateIsValid(): boolean {
    const dateFormat = this.authService.getCurrentUserDateFormat()
    const noExpiry = <boolean>this.form?.get('noExpiry')?.value
    const expDate = dayjs(<Dayjs>this.form?.get('expDate')?.value, dateFormat).tz()

    return noExpiry || (expDate.isValid() && expDate.isAfter(this.issueDate))
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DocumentItem,
    public dialogRef: MatDialogRef<RecordEditDialogComponent>,
    private fb: FormBuilder,
    private readonly authService: AuthService,
  ) {}

  ngOnInit(): void {
    const { data } = this

    this.form = this.fb.group({
      issueDate: dayjs(data.issueDate).tz(),
      noExpiry: data.noExpiry,
      expDate: data.expDate ? dayjs(data.expDate).tz() : null,
      cost: data.cost,
      note: data.note,
      files: data.files,
      removeFiles: [[]],
    })
  }

  removeFile(id: number) {
    const removeFiles = this.form.get('removeFiles')
    const removeIds = removeFiles.value as number[]
    removeFiles.setValue(removeIds.concat([id]))
    removeFiles.markAsDirty()
  }

  submitForm() {
    /* eslint-disable */
    const formData = this.form.value

    let data = {
      issueDate: dayjs(formData.issueDate).tz().hour(0).minute(0).second(0).format(),
      noExpiry: formData.noExpiry,
      expDate: formData.noExpiry ? null : dayjs(formData.expDate).tz().hour(0).minute(0).second(0).format(),
      cost: formData.cost,
      note: formData.note,
      files: formData.files,
      removeFiles: formData.removeFiles,
    }
    /* eslint-enable */

    this.dialogRef.close(data)
  }
}
